import * as React from "react";

import {
    MarketResearchSection,
    MarketResearchShareDialog,
    MarketResearchType,
    PageActionButton,
    ShareAltIcon,
    useMarketResearchContext,
} from "../../..";

type MarketResearchHeaderProps = {
    id: string;
    marketResearchType: MarketResearchType;
};

export const MarketResearchHeader = (props: MarketResearchHeaderProps) => {
    const { id, marketResearchType } = props;
    const {
        summary: { data: summaryData },
        share: { data: shareData },
    } = useMarketResearchContext();

    const [shareDialogOpen, setShareDialogOpen] = React.useState(false);

    const handleShareClose = () => {
        setShareDialogOpen(false);
    };

    const actions = () => {
        if (!!shareData && !!summaryData && marketResearchType.isPrivateJob()) {
            return (
                <PageActionButton
                    color="primary"
                    onClick={() => setShareDialogOpen(true)}
                >
                    <ShareAltIcon />
                </PageActionButton>
            );
        }
        return null;
    };

    return (
        <>
            <MarketResearchSection
                id={id}
                title="market research"
                actions={actions()}
            />
            {/* Summary data means valid and share data has URLs */}
            {!!shareData && !!summaryData && shareDialogOpen ? (
                <MarketResearchShareDialog
                    jobName={summaryData.jobTitle.jobName}
                    locationName={summaryData.locationName}
                    shortenedUrl={shareData.shortenedUrl}
                    emailUrl={shareData.emailUrl}
                    open={shareDialogOpen}
                    onClose={handleShareClose}
                />
            ) : null}
        </>
    );
};
